<template>
  <div>
    <h2 class="ViewHeading">Water Testing and Results</h2>
    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col>
          <b-card-group deck>
            <b-card
              border-variant="info"
              header="Tests Needing Reviewed"
              header-bg-variant="info"
              align="center"
            >
              <b-card-text
                >You have {{ UnderReviewTestCount }} results to be
                reviewed.</b-card-text
              >
            </b-card>
            <b-card
              border-variant="success"
              header="Tests Passed"
              header-bg-variant="success"
              align="center"
            >
              <b-card-text
                >You have {{ PassedTestCount }} Test(s) Passed in the last 28
                days.</b-card-text
              >
              <b-card-text></b-card-text>
            </b-card>
            <b-card
              border-variant="danger"
              header="Tests Beyond Thresholds"
              header-bg-variant="danger"
              align="center"
            >
              <b-card-text
                >You have {{ FailedTestCount }} Test(s) above dangerous levels
                in the last 28 days.</b-card-text
              >
              <b-card-text></b-card-text>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-row><br /></b-row>
    </div>
    <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Test Status" active>
            <div id="Table">
              <br />
              <h4>Test Status</h4>
              <br />
            </div>
            <b-tabs content-class="mt-3" fill v-model="testingTabs">
              <b-tab active title="Colony Testing">
                <b-table
                  id="CFUTable"
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="ColonyTestingItems"
                  :fields="ColonyTestingFields"
                  hover
                  small
                  show-empty
                  empty-text="You don't curently have any results to show"
                >
                  <template v-slot:cell(6)="{ item }">
                    <b-button
                      variant="outline-info"
                      v-on:click="showTestNotes(item, 'CFU')"
                      size="sm"
                      >Show</b-button
                    >
                  </template>
                  <template v-slot:cell(5)="{ item }">
                    <div v-if="item[5] === 'For Review'">
                      <b-badge variant="info">For Review</b-badge>
                    </div>
                    <div v-if="item[5] === 'New'">
                      <b-badge variant="secondary">New</b-badge>
                    </div>
                    <div v-if="item[5] === 'In Progress'">
                      <b-badge variant="light">In Progress</b-badge>
                    </div>
                  </template>

                  <template v-slot:cell(4)="{ item }">
                    <!-- {{ item[4] }} -->
                    <b-avatar
                      v-if="item[4] == 'Pass'"
                      variant="success"
                      rounded
                      size="2em"
                      >P</b-avatar
                    >
                    <b-avatar
                      v-if="item[4] == 'Fail'"
                      variant="danger"
                      rounded
                      size="2em"
                      >F</b-avatar
                    >
                    <b-avatar
                      v-if="item[4] === null"
                      variant="secondary"
                      rounded
                      size="2em"
                      >--</b-avatar
                    >
                  </template>
                </b-table>
              </b-tab>
              <b-tab title="Rapid Testing">
                <b-table
                  id="RapidTable"
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="RapidTestingItems"
                  :fields="RapidTestingFields"
                  hover
                  small
                  show-empty
                  empty-text="You don't curently have any results to show"
                >
                  <template v-slot:cell(6)="{ item }">
                    <b-button
                      variant="outline-info"
                      v-on:click="showTestNotes(item, 'Rapid')"
                      size="sm"
                      >Show</b-button
                    >
                  </template>
                  <template v-slot:cell(5)="{ item }">
                    <div v-if="item[5] === 'For Review'">
                      <b-badge variant="info">For Review</b-badge>
                    </div>
                    <div v-if="item[5] === 'New'">
                      <b-badge variant="secondary">New</b-badge>
                    </div>
                    <div v-if="item[5] === 'In Progress'">
                      <b-badge variant="light">In Progress</b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(4)="{ item }">
                    <b-avatar
                      v-if="item[4] == 'Pass'"
                      variant="success"
                      rounded
                      size="2em"
                      >P</b-avatar
                    >
                    <b-avatar
                      v-if="item[4] == 'Fail'"
                      variant="danger"
                      rounded
                      size="2em"
                      >F</b-avatar
                    >
                    <b-avatar
                      v-if="item[4] == null"
                      variant="secondary"
                      rounded
                      size="2em"
                      >--</b-avatar
                    >
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab title="Scheduled Tests" lazy>
            <div id="Table">
              <br />
              <h4>Scheduled Tests</h4>
              <br />

              <div>
                <b-table
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="ScheduledTestItems"
                  :fields="ScheduledTestFields"
                  hover
                  small
                >
                  <!-- <template v-slot:cell(9)="{ item }">
                    <b-button
                      variant="outline-info"
                      size="sm"
                      v-on:click="modifyTestBooking(item)"
                      >Modify</b-button
                    >
                  </template> -->
                  <template v-slot:cell(9)="{ item }">
                    <b-button
                      v-if="
                        item[12] == 'FALSE' ||
                          item[12] == '' ||
                          item[12] == null
                      "
                      size="sm"
                      variant="outline-info"
                      v-on:click="modifyTestBooking(item)"
                      >Modify</b-button
                    >
                    <b-badge v-if="item[12] == 'TRUE'">Under Edit</b-badge>
                  </template>
                </b-table>
                <b-row>
                  <b-col class="text-left">
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      @click="showAddNewTestModal()"
                    >
                      <BIconPlusSquare></BIconPlusSquare> Schedule New Test
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-tab>
          <!-- <b-tab title="Request Test" lazy>
            <b-card
              header-bg-variant="dark"
              border-variant="light"
              bg-variant="light"
            >
              <template #header>
                <h6 class="testHeader">New Test Request Form</h6>
              </template>
              <template #footer>
                <b-row>
                  <b-col class="centered">
                    <b-button
                      v-on:click="SubmitTestBooking()"
                      variant="outline-info"
                      small
                      >Submit</b-button
                    >
                    <b-button
                      v-on:click="ResetTestBooking()"
                      variant="outline-info"
                      small
                      >Reset</b-button
                    >
                  </b-col>
                </b-row>
              </template>
              <h5 class="accessoriesHeader">Test Type</h5>
              <b-row>
                <b-col>
                  <b-form-select
                    :options="TestType"
                    v-model="newBooking.TestType"
                  ></b-form-select>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <b-form-select
                    id="input-3"
                    v-model="newBooking.Type"
                    :options="tests"
                    required
                  ></b-form-select>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col>
                  <b-form-input
                    id="OutletID"
                    v-model="newBooking.OutletID"
                    placeholder="OutletID"
                    required
                  ></b-form-input>
                </b-col>
                <b-col>
                  <b-form-input
                    id="Area"
                    v-model="newBooking.Room"
                    placeholder="Room/Area"
                    required
                  ></b-form-input>
                </b-col>
                <b-col>
                  <b-form-input
                    id="LocationNote"
                    v-model="newBooking.Note"
                    placeholder="Location Note"
                    required
                  ></b-form-input>
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <h5 class="accessoriesHeader">Date</h5>
                  <b-form-datepicker
                    id="input-4"
                    v-model="newBooking.Date"
                    class="mb-2"
                  ></b-form-datepicker>
                </b-col>
                <b-col>
                  <h5 class="accessoriesHeader">Time</h5>

                  <b-form-timepicker
                    locale="en"
                    v-model="newBooking.Time"
                  ></b-form-timepicker>
                </b-col>
              </b-row>
              <hr />
              <h5 class="accessoriesHeader">Contact Information</h5>
              <b-row>
                <b-col>
                  <b-form-input
                    placeholder="Email Address"
                    v-model="newBooking.Email"
                  ></b-form-input>
                </b-col>
                <b-col>
                  <b-col>
                    <b-form-input
                      id="input-2"
                      v-model="newBooking.Name"
                      placeholder="Enter name"
                      required
                    ></b-form-input>
                  </b-col>
                </b-col>
              </b-row>
            </b-card>
          </b-tab> -->
          <b-tab lazy title="Completed">
            <br />
            <h4 class="centered">Completed Tests</h4>
            <br />

            <b-table
              sticky-header
              no-border-collapse
              responsive
              hover
              small
              :items="CompletedTestsItems"
              :fields="CompletedTestsFields"
              show-empty
              empty-text="You have no completed tests."
            >
              <template v-slot:cell(TestResult)="{ item }">
                <b-avatar
                  v-if="item.TestResult === 'Pass'"
                  variant="success"
                  rounded
                  size="2em"
                  >P
                </b-avatar>
                <b-avatar
                  v-if="item.TestResult === 'Fail'"
                  variant="danger"
                  rounded
                  size="2em"
                  >F
                </b-avatar>
              </template>
              <template v-slot:cell(Details)="{ item }">
                <b-button
                  variant="outline-info"
                  size="sm"
                  v-on:click="showCompleteDetails(item)"
                >
                  Details
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>

    <section
      class="noshow"
      v-if="(this.doPDF == true) & (this.modalShowing == true)"
    >
      <PDF v-if="this.doPDF == true" :key="componentKey"> </PDF>
    </section>
    <b-modal
      ref="TestResultsModal"
      id="TestResultsModal"
      title="Test Result Notes"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      v-model="modalShowing"
    >
      <h4>Test ID: {{ this.modalItem[0] }}</h4>
      <h5>Outlet ID: {{ this.modalDetails[4] }}</h5>

      <!-- {{ this.modalDetails }} -->
      <b-card :header-bg-variant="this.OverallColour">
        <template #header>
          <h6>Test Outcome - {{ TestResult }}</h6>
        </template>
        <b-row
          ><b-col>
            <label class="boldLabel">Test </label>
          </b-col>
          <b-col>
            <label class="boldLabel">Location </label>
          </b-col>
        </b-row>
        <b-row>
          <b-col>{{ this.modalDetails[0] }}</b-col>
          <b-col>{{ this.modalDetails[1] }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col><label class="boldLabel">Flush Type</label></b-col>
          <b-col><label class="boldLabel">Outlet Type</label></b-col>
        </b-row>
        <b-row>
          <b-col>{{ this.modalDetails[2] }}</b-col>
          <b-col>{{ this.modalDetails[3] }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col><label class="boldLabel">Sample Date</label></b-col>
          <b-col><label class="boldLabel">Sample Time</label></b-col>
        </b-row>

        <b-row>
          <b-col>{{ this.modalDetails[5] }}</b-col>
          <b-col>{{ this.modalDetails[6] }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col><label class="boldLabel">Test Commenced Date</label></b-col>
          <b-col><label class="boldLabel">Test Commenced Time</label></b-col>
        </b-row>

        <b-row>
          <b-col>{{ this.modalDetails[10] }}</b-col>
          <b-col>{{ this.modalDetails[11] }}</b-col>
        </b-row>

        <template
          #footer
          v-if="
            this.modalDetails[8] == 'For Review' ||
              this.modalDetails[8] == 'Completed'
          "
        >
          <b-card>
            <b-row>
              <b-col>
                <b-button
                  v-on:click="showDetailsColony()"
                  size="sm"
                  variant="outline-secondary"
                  ><BIconListUl></BIconListUl> Show Details</b-button
                ></b-col
              >
              <b-col v-if="modalDetails[8] == 'Completed'">
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  v-on:click="DownloadTestDetails(modalItem[0])"
                >
                  <BIconDownload></BIconDownload> Download Details</b-button
                ></b-col
              >

              <b-col v-if="modalDetails[8] != 'Completed'">
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  v-on:click="MarkAsReviewed(modalItem)"
                  >Mark as Reviewed</b-button
                >
              </b-col>
            </b-row>
            <template #footer> </template>
          </b-card>
        </template>
      </b-card>
    </b-modal>
    <b-modal
      size="xl"
      header-bg-variant="dark"
      header-text-variant="light"
      ref="ColonyDetail"
      id="ColonyDetail"
      :title="'Test ' + modalItem[0]"
    >
      <b-card :header-bg-variant="OverallColour">
        <template #header> Test Result - {{ ColonyDetails[7] }} </template>
        <b-row>
          <b-col><label class="boldLabel">Test Type</label></b-col>
          <b-col><label class="boldLabel">Outlet Details</label></b-col>
        </b-row>

        <b-row>
          <b-col>{{ this.ColonyDetails[0] }}</b-col>
          <b-col>{{
            this.ColonyDetails[3] + " - " + this.ColonyDetails[4]
          }}</b-col>
        </b-row>
        <hr />
        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella cfu/1000ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 1 cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>

          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 2-14 cfu/1000 ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella species non pneumophila cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
          <br />
        </section>

        <!-- DO THE THING -->
        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Legionella MPN</label></b-col>
            <b-col><label class="boldLabel">Legionella Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 37°C [2 days] cfu/ml MW3</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 22°C [3 days] cfu/ml MW3</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[16] }}</b-col>
            <b-col>{{ this.ColonyDetails[17] }}</b-col>
          </b-row>

          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Pseudomonas aeruginosa cfu/100 ml MW4</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Total Coliforms cfu/100 ml MW10</label
              ></b-col
            >
          </b-row>
          <b-row>
            <b-col>{{ this.ColonyDetails[18] }}</b-col>
            <b-col>{{ this.ColonyDetails[19] }}</b-col>
          </b-row>
          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Escherichia coli cfu/100 ml MW10</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Pseudomonas 30 °C cfu/ml MW32</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[20] }}</b-col>
            <b-col>{{ this.ColonyDetails[21] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'For Review')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Pseudomonas MPN</label></b-col>
            <b-col><label class="boldLabel">Pseudomonas Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
        </section>

        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella cfu/1000ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 1 cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>

          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 2-14 cfu/1000 ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella species non pneumophila cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
          <br />
        </section>

        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Legionella MPN</label></b-col>
            <b-col><label class="boldLabel">Legionella Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 0) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 37°C [2 days] cfu/ml MW3</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 22°C [3 days] cfu/ml MW3</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[16] }}</b-col>
            <b-col>{{ this.ColonyDetails[17] }}</b-col>
          </b-row>

          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Pseudomonas aeruginosa cfu/100 ml MW4</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Total Coliforms cfu/100 ml MW10</label
              ></b-col
            >
          </b-row>
          <b-row>
            <b-col>{{ this.ColonyDetails[18] }}</b-col>
            <b-col>{{ this.ColonyDetails[19] }}</b-col>
          </b-row>
          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Escherichia coli cfu/100 ml MW10</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Pseudomonas 30 °C cfu/ml MW32</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[20] }}</b-col>
            <b-col>{{ this.ColonyDetails[21] }}</b-col>
          </b-row>
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.testingTabs == 1) &
              (this.ColonyDetails[8] == 'Completed')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Pseudomonas MPN</label></b-col>
            <b-col><label class="boldLabel">Pseudomonas Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
        </section>
        <!-- <b-spinner></b-spinner> -->
      </b-card>
    </b-modal>
    <b-modal
      ref="ModifyTestBookingModal"
      id="ModifyTestBookingModal"
      title="Test Booking"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card>
        <b-row class="mt-2">
          <b-col cols="4" class="modify-text-left">TestID</b-col>

          <b-col cols="8">
            {{ ModifiedBooking.ServiceID }}
          </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Test Room/Area</b-col>
          <b-col cols="8">
            <input type="text" v-model="ModifiedBooking.Area" required />
          </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Location Note</b-col>
          <b-col cols="8"
            ><input type="text" v-model="ModifiedBooking.Room" required />
          </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Test Type</b-col>
          <b-col cols="8">{{ ModifiedBooking.Type }} </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Test Description</b-col>
          <b-col cols="8"
            ><input
              type="text"
              v-model="ModifiedBooking.Description"
              required
            />
          </b-col>
        </b-row>
        <b-row class="mt-2"
          ><b-col cols="4" class="modify-text-left">Arranged By</b-col>
          <b-col cols="8">
            {{ ModifiedBooking.ArrangedBy }}
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col class="boldLabel"
            >Scheduled Date:
            <b-form-datepicker
              locale="en"
              :placeholder="ModifiedBooking.Date"
              v-model="ModifiedBooking.Date"
            ></b-form-datepicker
          ></b-col>
        </b-row>
        <b-row>
          <b-col class="boldLabel"
            >Scheduled Time:
            <b-form-timepicker
              locale="en"
              :placeholder="ModifiedBooking.Time"
              v-model="ModifiedBooking.Time"
            ></b-form-timepicker
          ></b-col>
        </b-row>
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row>
          <b-col
            ><b-button
              variant="outline-info"
              v-on:click="SubmitModifiedBooking()"
              >Submit Changes</b-button
            ></b-col
          >
          <b-col
            ><b-button
              variant="outline-info"
              v-on:click="CancelModifiedBooking()"
              >Cancel Changes</b-button
            ></b-col
          >
        </b-row>
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <!-- <b-row>
          <b-col
            ><b-button block variant="outline-danger"
              >Cancel Test Completely</b-button
            ></b-col
          >
        </b-row> -->
      </b-card>
    </b-modal>

    <b-modal
      ref="newTestBooking"
      id="newTestBooking"
      title="Test Booking"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card
        header-bg-variant="dark"
        border-variant="light"
        bg-variant="light"
      >
        <template #header>
          <h6 class="testHeader">New Test Request Form</h6>
        </template>

        <h5 class="accessoriesHeader">Test Type</h5>
        <b-row>
          <b-col>
            <b-form-select
              :options="TestType"
              v-model="newBooking.TestType"
            ></b-form-select>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-select
              id="input-3"
              v-model="newBooking.Type"
              :options="tests"
              required
            ></b-form-select>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Outlet</h5>
            <b-form-input
              id="OutletID"
              v-model="newBooking.OutletID"
              placeholder="OutletID"
              required
            ></b-form-input>
          </b-col>
          <b-col>
            <h5 class="accessoriesHeader">Room/Area</h5>
            <b-form-input
              id="Area"
              v-model="newBooking.Room"
              placeholder="Room/Area"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Location Note</h5>
            <b-form-input
              id="LocationNote"
              v-model="newBooking.Note"
              placeholder="Location Note"
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <h5 class="accessoriesHeader">Date</h5>
            <b-form-datepicker
              id="input-4"
              v-model="newBooking.Date"
              class="mb-2"
            ></b-form-datepicker>
          </b-col>
          <b-col>
            <h5 class="accessoriesHeader">Time</h5>

            <b-form-timepicker
              locale="en"
              v-model="newBooking.Time"
            ></b-form-timepicker>
          </b-col>
        </b-row>
        <hr />
        <h5 class="accessoriesHeader">Contact Information</h5>
        <b-row>
          <b-col>
            <b-form-input
              placeholder="Email Address"
              v-model="newBooking.Email"
            ></b-form-input>
          </b-col>
          <b-col>
            <b-col>
              <b-form-input
                id="input-2"
                v-model="newBooking.Name"
                placeholder="Enter name"
                required
              ></b-form-input>
            </b-col>
          </b-col>
        </b-row>
        <template #footer>
          <b-row>
            <b-col class="centered">
              <b-button
                v-on:click="SubmitTestBooking()"
                variant="outline-info"
                small
                >Submit</b-button
              >
              <b-button
                v-on:click="ResetTestBooking()"
                variant="outline-info"
                small
                >Reset</b-button
              >
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { BIconDownload, BIconListUl, BIconPlusSquare } from "bootstrap-vue";
import PDF from "./PDFTemplate.vue";
import Vue from "vue";
export default {
  computed: {},
  components: {
    BIconDownload,
    BIconListUl,
    BIconPlusSquare,
    PDF,
  },

  data() {
    return {
      testingTabs: 0,
      CompletedTestArray: [],
      CompletedTestsItems: [],
      CompletedTestsFields: [
        { key: "TestID", label: "Test ID", variant: "primary" },
        { key: "TestVariant", label: "Test Variant" },
        { key: "TestType", label: "Test Type" },
        { key: "TestDesc", label: "Test Desc" },
        { key: "SampleDate", label: "Sample Date" },
        { key: "TestResult", label: "Test Result" },
        // { key: "TestStatus", label: "Test Status" },
        { key: "Details", label: "Details" },
      ],
      ScheduledTestItems: [],
      ScheduledTestFields: [
        { key: "0", label: "Service ID", variant: "primary" },
        { key: "1", label: "Type" },
        { key: "2", label: "Category" },
        { key: "3", label: "Service Note" },
        { key: "4", label: "Room/Area" },
        { key: "5", label: "Location Note" },
        { key: "6", label: "Arranged by" },
        { key: "7", label: "Scheduled Date" },
        { key: "8", label: "Scheduled Time" },
        { key: "9", label: "Modify" },
      ],
      RapidTestingItems: [],
      RapidTestingFields: [
        { key: "0", label: "Test ID", variant: "primary" },
        { key: "1", label: "Test Type" },
        { key: "2", label: "Location" },
        { key: "3", label: "Sample Date" },
        { key: "4", label: "Test Result" },
        { key: "5", label: "Test Status" },
        { key: "6", label: "Details" },
      ],
      ColonyTestingFields: [
        { key: "0", label: "Test ID", variant: "primary" },
        { key: "1", label: "Test Type" },
        { key: "2", label: "Location" },
        { key: "3", label: "Sample Date" },
        { key: "4", label: "Test Result" },
        { key: "5", label: "Test Status" },
        { key: "6", label: "Details" },
      ],
      ColonyTestingItems: [],
      UnderReviewTestCount: "",
      PassedTestCount: "",
      FailedTestCount: "",
      TestVariation: null,
      TestType: [
        { text: "Colony or Rapid", value: null, disabled: true },
        "Colony Water Test",
        "Rapid Water Test",
      ],
      SelectOptions: ["Yes", "No"],
      newBooking: {
        Type: null,
        TestType: null,
        OutletID: null,
        Room: null,
        Note: null,
        Date: null,
        Email: null,
        Name: null,
        Time: null,
      },
      tests: [
        { text: "Select Test Type", value: null, disabled: true },
        "Full Test",
        "Legionella Only",
        "Pseudomonas Only",
        "Other",
      ],
      response: null,
      modal: false,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      ID: "",
      TestLocation: "",
      TestRoom: "",
      TestDesc: "",
      TestOutlet: "",
      TestDate: "",
      TestLegionTVC: "",
      TestLegion: "",
      TestPseudoTVC: "",
      TestPseudo: "",
      LegionColour: "",
      PseudoColour: "",
      OverallColour: "",
      testvar: "",
      testtype: "",
      modalItem: [],
      modifyItem: [],
      modalDetails: [],
      TestResult: "",
      ColonyDetails: "",
      ModifiedBooking: {
        ServiceID: null,
        Area: null,
        Description: null,
        Room: null,
        Type: null,
        ArrangedBy: null,
        Date: null,
        Time: null,
      },
      PDFData: null,
      doPDF: false,
      componentKey: 0,
      modalShowing: null,
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = {
      ServiceType: "WaterTesting",
      RequestType: "TestCounts",
      DataDict: [{ Location: this.selectedlocation }],
    };
    axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
      this.FailedTestCount = response.data.TestsFailed;
      this.PassedTestCount = response.data.TestsPassed;
      this.UnderReviewTestCount = response.data.TestsUnderReview;
    });

    let LookUpUrlTestStatus =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookupHeadersTestStatus = this.$apikeyPost;
    let LookupRequestTestStatus = {
      ServiceType: "WaterTesting",
      RequestType: "TestStatus",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlTestStatus,
        LookupRequestTestStatus,
        LookupHeadersTestStatus
      )
      .then((response) => {
        this.ColonyTestingItems = response.data.ColonyTests.Values;
        this.RapidTestingItems = response.data.RapidTests.Values;
      });

    let LookUpUrlScheduledTests =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersScheduledTests = this.$apikeyPost;
    let LookUpRequestScheduledTests = {
      ServiceType: "WaterTesting",
      RequestType: "ScheduledTests",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpUrlScheduledTests,
        LookUpRequestScheduledTests,
        LookUpHeadersScheduledTests
      )
      .then((response) => {
        this.ScheduledTestItems = response.data.Values;
      });

    let LookUpURLCompletedTests =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCompletedTests = this.$apikeyPost;
    let LookUpRequestCompletedTests = {
      ServiceType: "WaterTesting",
      RequestType: "CompletedTests",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpURLCompletedTests,
        LookUpRequestCompletedTests,
        LookUpHeadersCompletedTests
      )
      .then((response) => {
        this.CompletedTestArray = response.data.Values;

        for (let i = 0; i < this.CompletedTestArray.length; i++) {
          this.CompletedTestsItems.push({
            TestID: this.CompletedTestArray[i][0],
            TestType: this.CompletedTestArray[i][1],
            TestDesc: this.CompletedTestArray[i][3],
            SampleDate: this.CompletedTestArray[i][4],
            TestResult: this.CompletedTestArray[i][5],
            TestStatus: this.CompletedTestArray[i][6],
            TestVariant: this.CompletedTestArray[i][2],
          });
        }
      });
  },

  methods: {
    showDetailsColony() {
      this.ColonyDetails = this.modalDetails;

      this.$refs["ColonyDetail"].show();
    },
    showTestNotes(item, testtype) {
      let SpeedofTest = "";
      if (this.testingTabs == 0) {
        SpeedofTest = "CFUTestDetails";
      }
      if (this.testingTabs == 1) {
        SpeedofTest = "RapidTestDetails";
      }

      let LookUpUrlDetails =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersDetails = this.$apikeyPost;
      let LookUpRequestDetails = {
        ServiceType: "WaterTesting",
        RequestType: SpeedofTest,
        DataDict: [
          {
            TestID: item[0],
          },
        ],
      };
      axios
        .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
        .then((response) => {
          this.modalDetails = response.data.Values[0];
          this.modalItem = item;
          this.testtype = testtype;
          this.TestLegion = item.LegionellaResult;
          this.TestPseudo = item.PseudomonasResult;
          this.TestResult = item[4];
          this.testStatus = this.modalDetails[8];

          if (this.TestLegion == "Pass") {
            this.LegionColour = "success";
          } else if (this.TestLegion == "Fail") {
            this.LegionColour = "danger";
          } else {
            this.LegionColour = "secondary";
          }

          if (this.TestPseudo == "Pass") {
            this.PseudoColour = "success";
          } else if (this.TestPseudo == "Fail") {
            this.PseudoColour = "danger";
          } else {
            this.PseudoColour = "secondary";
          }

          if (this.TestResult == "Pass") {
            this.OverallColour = "success";
          } else if (this.TestResult == "Fail") {
            this.OverallColour = "danger";
          } else {
            this.OverallColour = "secondary";
          }

          this.$refs["TestResultsModal"].show(
            this.testvar,
            this.testtype,
            this.LegionColour,
            this.PseudoColour,
            this.OverallColour
          );
        });
    },
    SubmitTestBooking() {
      // let name = localStorage.getItem("fullname");
      if (
        this.newBooking.Type == null ||
        this.newBooking.Room == null ||
        this.newBooking.Note == null ||
        this.newBooking.TestType == null ||
        this.newBooking.Name == null ||
        this.newBooking.OutletID == null ||
        this.newBooking.Date == null ||
        this.newBooking.Time == null ||
        this.newBooking.Email == null
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        // let LookUpUrlScheduledTests =
        //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        //   this.$environment +
        //   "/service";
        // let LookUpHeadersScheduledTests = this.$apikeyPost;
        // let LookUpRequestScheduledTests = {
        //   RequestType: "CreateRequest",
        //   RequestVariable: "",
        //   DataDict: [
        //     {
        //       OriginID: "",
        //       Type: "WMS",
        //       Category: "Water Test",
        //       ServiceNote:
        //         this.newBooking.TestType + " " + this.newBooking.Type,
        //       EndpointType: "Outlet",
        //       EndpointID: this.newBooking.OutletID,
        //       Location: this.selectedlocation,
        //       DeptFloor: this.newBooking.Room,
        //       Position: "",
        //       LocationNote: this.newBooking.Note,
        //       ArrangedBy: name,
        //       ScheduledDate: this.newBooking.Date,
        //       ScheduledTime: this.newBooking.Time,
        //       AssignedTo: "",
        //     },
        //   ],
        // };
        // axios
        //   .post(
        //     LookUpUrlScheduledTests,
        //     LookUpRequestScheduledTests,
        //     LookUpHeadersScheduledTests
        //   )
        //   .then((response) => {
        //     response;
        //     this.ScheduledTestItems = response.data.Values;
        //     alert("Booking Request has been submitted");
        //     this.newBooking = {};
        //   });
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "New Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.newBooking.Name +
            "\\n" +
            this.newBooking.Email +
            "\\n\\n" +
            "Test Information " +
            "\\n\\n" +
            "Test Type" +
            this.newBooking.TestType +
            " " +
            this.newBooking.Type +
            "\\n" +
            "Room - " +
            this.newBooking.Room +
            "\\n" +
            "Outlet  - " +
            this.newBooking.OutletID +
            "\\n" +
            "Location Note " +
            this.newBooking.Note +
            " Date and Time - " +
            this.newBooking.Date +
            " at " +
            this.newBooking.Time,

          EmailSubject: "New Test Booking ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted, A staff member will be in touch."
        );
        // this.resetService();

        // alert("Booking Request has been submitted");
        this.newBooking = {};
      }
    },
    ResetTestBooking() {
      this.newBooking = {};
    },
    modifyTestBooking(item) {
      this.ModifiedBooking = {};
      this.ModifiedBooking = {
        ServiceID: item[0],
        Area: item[4],
        Description: item[3],
        Room: item[5],
        Type: item[2],
        ArrangedBy: item[6],
        Date: item[7],
        Time: item[8],
      };
      this.$refs["ModifyTestBookingModal"].show(this.ModifiedBooking);
    },
    SubmitModifiedBooking() {
      // if (
      //   this.ModifiedBooking.Area == "" ||
      //   this.ModifiedBooking.Description == "" ||
      //   this.ModifiedBooking.Room == "" ||
      //   this.ModifiedBooking.Date == "" ||
      //   this.ModifiedBooking.Time == ""
      // ) {
      //   alert("Please complete all fields to submit Booking request");
      // } else {
      //   let LookUpUrl =
      //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //     this.$environment +
      //     "/service";
      //   let LookUpHeaders = this.$apikeyPost;
      //   this.LookUpRequest = {
      //     RequestType: "ModifyRequest",

      //     RequestVariable: "",

      //     DataDict: [
      //       {
      //         ServiceNote: this.ModifiedBooking.Description,
      //         DeptFloor: this.ModifiedBooking.Area,
      //         LocationNote: this.ModifiedBooking.Room,
      //         ScheduledDate: this.ModifiedBooking.Date,
      //         ScheduledTime: this.ModifiedBooking.Time,
      //         ServiceID: this.ModifiedBooking.ServiceID,
      //       },
      //     ],
      //   };

      //   axios
      //     .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      //     .then((response) => {
      //       response;
      //       alert("Update Submitted");
      //       this.$refs["ModifyTestBookingModal"].hide();
      //       this.resetScheduledTests();
      //     });
      // }

      if (
        this.ModifiedBooking.Area == "" ||
        this.ModifiedBooking.Description == "" ||
        this.ModifiedBooking.Room == "" ||
        this.ModifiedBooking.Date == "" ||
        this.ModifiedBooking.Time == ""
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "Modify Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.name +
            "\\n\\n" +
            "Appointment Information " +
            "\\n\\n" +
            this.ModifiedBooking.ServiceID +
            "\\n" +
            "Type - " +
            this.ModifiedBooking.Description +
            "\\n " +
            this.ModifiedBooking.Type +
            "\\n" +
            "Room - " +
            this.ModifiedBooking.Room +
            "\\n" +
            "Area  - " +
            this.ModifiedBooking.Area +
            "\\n" +
            "New Date and Time - " +
            this.ModifiedBooking.Date +
            " at " +
            this.ModifiedBooking.Time,

          EmailSubject: "Service Request Booking Modification ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted,An Angel Guard staff member will be in touch."
        );

        let ScheduledUpdateURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/service";
        let ScheduledUpdateHeaders = this.$apikeyPost;
        let ScheduledUpdateRequest = {
          RequestType: "UpdateService",
          RequestVariable: "",
          DataDict: [
            {
              ServiceID: this.ModifiedBooking.ServiceID,
              Status: "",
              UnderEdit: "TRUE",
            },
          ],
        };
        axios
          .post(
            ScheduledUpdateURL,
            ScheduledUpdateRequest,
            ScheduledUpdateHeaders
          )
          .then((response) => {
            response;
            this.resetScheduledTests();
          });
        this.$refs["ModifyTestBookingModal"].hide();
      }
    },

    resetScheduledTests() {
      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        ServiceType: "WaterTesting",
        RequestType: "ScheduledTests",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          response;
          this.ScheduledTestItems = response.data.Values;
        });
    },
    CancelModifiedBooking() {
      this.ModifiedBooking = {};
      this.$refs["ModifyTestBookingModal"].hide();
    },
    showCompleteDetails(item) {
      let SpeedofTest = "";
      let testtype = "";

      if (item.TestVariant == "Colony") {
        SpeedofTest = "CFUTestDetails";
        testtype = "CFU";
        this.testingTabs = 0;
      }
      if (item.TestVariant == "Rapid") {
        SpeedofTest = "RapidTestDetails";
        testtype = "Rapid";
        this.testingTabs = 1;
      }

      let LookUpUrlDetails =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersDetails = this.$apikeyPost;
      let LookUpRequestDetails = {
        ServiceType: "WaterTesting",
        RequestType: SpeedofTest,
        DataDict: [
          {
            TestID: item.TestID,
          },
        ],
      };
      axios
        .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
        .then((response) => {
          this.modalDetails = response.data.Values[0];
          this.modalItem = item;
          this.modalItem[0] = item.TestID;
          this.testtype = testtype;
          this.TestLegion = item.LegionellaResult;
          this.TestPseudo = item.PseudomonasResult;
          this.TestResult = item.TestResult;
          this.testStatus = this.modalDetails[8];

          Vue.prototype.$modalDetails = this.modalDetails;

          if (this.TestLegion == "Pass") {
            this.LegionColour = "success";
          } else if (this.TestLegion == "Fail") {
            this.LegionColour = "danger";
          } else {
            this.LegionColour = "secondary";
          }

          if (this.TestPseudo == "Pass") {
            this.PseudoColour = "success";
          } else if (this.TestPseudo == "Fail") {
            this.PseudoColour = "danger";
          } else {
            this.PseudoColour = "secondary";
          }

          if (this.TestResult == "Pass") {
            this.OverallColour = "success";
          } else if (this.TestResult == "Fail") {
            this.OverallColour = "danger";
          } else {
            this.OverallColour = "secondary";
          }

          this.$refs["TestResultsModal"].show(
            this.testvar,
            this.testtype,
            this.LegionColour,
            this.PseudoColour,
            this.OverallColour
          );
        });
    },
    DownloadTestDetails(id) {
      this.doPDF = false;

      Vue.prototype.$PDFData = this.PDFData;
      Vue.prototype.$modalDetails = this.modalDetails;
      Vue.prototype.$TestType = this.testingTabs;
      Vue.prototype.$PDFType = "WaterTest";
      this.componentKey += 1;

      this.doPDF = true;

      // this.$router.push("PDF");

      id;
      // alert("download pushed for " + id);
    },
    MarkAsReviewed(id) {
      let SpeedofTest = "";
      if (this.testingTabs == 0) {
        SpeedofTest = "CFU";
      }
      if (this.testingTabs == 1) {
        SpeedofTest = "Rapid";
      }

      let LookUpUrlDetails =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersDetails = this.$apikeyPost;
      let LookUpRequestDetails = {
        ServiceType: "WaterTesting",
        RequestType: "UpdateTestStatus",
        DataDict: [
          {
            TestID: id[0],
            Status: "Completed",
            TestVariant: SpeedofTest,
          },
        ],
      };
      axios
        .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
        .then((response) => {
          response;
          this.$refs["TestResultsModal"].hide();
          this.resetTestTables();
        });
      alert("Test " + id[0] + " has been completed");
    },
    resetTestTables() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpRequest = {
        ServiceType: "WaterTesting",
        RequestType: "TestCounts",
        DataDict: [{ Location: this.selectedlocation }],
      };
      axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
        response;
        this.FailedTestCount = response.data.TestsFailed;
        this.PassedTestCount = response.data.TestsPassed;
        this.UnderReviewTestCount = response.data.TestsUnderReview;
      });

      let LookUpUrlTestStatus =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookupHeadersTestStatus = this.$apikeyPost;
      let LookupRequestTestStatus = {
        ServiceType: "WaterTesting",
        RequestType: "TestStatus",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlTestStatus,
          LookupRequestTestStatus,
          LookupHeadersTestStatus
        )
        .then((response) => {
          this.ColonyTestingItems = response.data.ColonyTests.Values;
          this.RapidTestingItems = response.data.RapidTests.Values;
        });

      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        ServiceType: "WaterTesting",
        RequestType: "ScheduledTests",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          this.ScheduledTestItems = response.data.Values;
        });

      let LookUpURLCompletedTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCompletedTests = this.$apikeyPost;
      let LookUpRequestCompletedTests = {
        ServiceType: "WaterTesting",
        RequestType: "CompletedTests",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpURLCompletedTests,
          LookUpRequestCompletedTests,
          LookUpHeadersCompletedTests
        )
        .then((response) => {
          this.CompletedTestArray = response.data.Values;

          for (let i = 0; i < this.CompletedTestArray.length; i++) {
            this.CompletedTestsItems.push({
              TestID: this.CompletedTestArray[i][0],
              TestType: this.CompletedTestArray[i][1],
              TestDesc: this.CompletedTestArray[i][3],
              SampleDate: this.CompletedTestArray[i][4],
              TestResult: this.CompletedTestArray[i][5],
              TestStatus: this.CompletedTestArray[i][6],
              TestVariant: this.CompletedTestArray[i][2],
            });
          }
        });
    },
    showAddNewTestModal() {
      this.$refs["newTestBooking"].show();
    },
  },
  watch: {
    modalShowing() {
      this.doPDF = false;
    },
  },
};
</script>

<style>
h1 {
  color: #212529;
}
#Table {
  margin: auto;
  text-align: center;
}

#Heading {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.modal {
  text-align: center;
}

.modify-text-left {
  text-align: left;
  font-weight: bold;
}
.boldLabel {
  font-weight: bold;
}
.test {
  float: right;
}
.testHeader {
  text-align: center;
  color: azure;
  font-size: 20px;
}
#modalTextArea {
  text-align: center;
  background: white;
  cursor: default;
}
</style>
